import React, { Component } from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import history from './helpers/history';

import TopBar from './components/common/top-bar';
import Home from './components/home';

class App extends Component {
  render() {
    return (
      <Router history={history}>
        <div className="fm-app">
          <TopBar />
          <Switch>
            <Route path="/" component={Home} />
          </Switch>
        </div>
      </Router>
    );
  }
}

export default App;
